<template>
    <div class="holder">
        <Loader v-if="loading" :show-full="false" loading-text="Loading"/>
        <div class="row">
            <div class="col-12" style="margin-bottom: 20px">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">{{getName}} <span @click="editIntentName"
                                                                 style="font-size: .6em;color: blue"><i
                                class="grab mdi mdi-pencil-box"></i>Edit/Add Name</span></h4>
                        <p class="card-description">What the bot understands ?</p>
                        <div class="focused_text">{{focused}}</div>

                        <button v-bind:class="{disabled:getName.length<2}" @click="saveChanges(getGroupID)" class="btn btn-gradient-primary save_all">
                            <i class="mdi mdi-content-save-all"></i> Save Changes
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="!loading ">
            <div class="col-5" style="margin-bottom: 100px">
                <div class="card">
                    <div class="card-body" style="padding: 2.5rem 1.5rem;">
                        <h4 class="card-title">{{utteranceLength}} Utterance{{utteranceLength>1?"s":""}}</h4>
                        <p class="card-description">User says ?</p>
                        <div class="row">
                            <div class="create_new">
                                <button @click="createUtterance" type="button"
                                        class="btn btn-sm btn-success btn-icon-text">
                                    <i class="mdi mdi-plus"></i> New Utterance
                                </button>
                            </div>
                            <!--<div class="col-12">-->
                            <!--<div class="input-group mb-2 mr-sm-2">-->
                            <!--<div class="input-group-prepend">-->
                            <!--<div class="input-group-text"><i class="mdi mdi-search-web"></i></div>-->
                            <!--</div>-->
                            <!--<input v-model="searchKey" type="text" class="form-control"-->
                            <!--id="inlineFormInputGroupUsername2" placeholder="Search Utterances">-->
                            <!--</div>-->

                            <!--</div>-->


                        </div>


                        <div class="list-wrapper">

                            <Datatable :columns="columns" :data="allUtterance" :loading="loading"
                                       @delete="deleteUtterance" :actions="actions"></Datatable>

                            <div class="flex-row flex-sb flex-c m-t-20 w-full">
                                <download-excel
                                        class="btn btn-primary btn-sm  "
                                        :data="allUtterance"
                                        :fields="columnsExport"
                                        worksheet="Utterances"
                                        name="utterances.xls">

                                    <i class="mdi mdi-export"></i> Export All

                                </download-excel>
                                <div class="btn btn-success btn-sm" @click="uploadMultiple">
                                    <i class="mdi mdi-import"></i> Import CSV
                                </div>
                            </div>

                        </div>
                        <!--<div class="row">-->
                        <!--<div class="col-12">-->
                        <!--<div id="pagination" class="pagination">-->
                        <!--<button @click="prevPage" :disabled="currentPageIndex===0">-->
                        <!--Previous-->
                        <!--</button>-->
                        <!--<button @click="nextPage" :disabled="currentPageIndex >= pages -1">-->
                        <!--Next-->
                        <!--</button>-->

                        <!--</div>-->
                        <!--</div>-->
                        <!--</div>-->
                    </div>
                </div>

            </div>
            <div class="col-7">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">Responses</h4>
                        <p class="card-description">Bot Replies ?</p>
                        <responses :key="updateKey" @onFocus="onFocusResponse" @onCreate="onCreateResponse"
                                   @onUpdate="onUpdateResponse"
                                   @onDelete="onDeleteResponse" :responses="this.responses"></responses>
                    </div>
                </div>

            </div>


        </div>
        <modal name="multi-upload">
            <Loader loading-text="Processing" v-if="uploading"></Loader>
            <div class="flex-c-m w-full flex-col h-full">
                <h2>Upload Utterances</h2>
                <p>Select a file with multiple utterances in csv </p>
                <input type="file" id="file" accept=".csv" @change="onFileChange"/>
                <label for="file">choose a file</label>
            </div>

        </modal>
    </div>
</template>

<script>
    import Loader from "../../components/Loader/Loader.vue";
    import Responses from '../../components/Responses/responses.vue'
    import {userService} from '../../services/user.service';
    import Datatable from "../../components/Datatable/Datatable";

    const action = [

        {
            p_class: 'text-right',
            class: '',
            actionType: 'click',
            callback: 'delete',
            args: ['#', 'Utterance'],
            text: '',
            icon: "remove mdi mdi-delete-circle ",

        },


    ];
    export default {
        name: "DetailIntent",
        components: {Datatable, Loader, Responses},
        props: ['intent'],
        data() {
            return {
                uploading: false,
                loading: false,
                intent_id: "",
                _intent: null,
                pageNo: 1,
                utterances: [],
                currentPageIndex: 0,
                responses: [],
                tableData: null,

                table: null,
                newJson: {},
                newUtterances: [],
                intentName: this.intent ? this.intent.name : "",
                focused: "",
                searchKey: '',
                updateKey: 0,

                title: "utterances",
                columns: ['#', 'Utterance'],
                columnsExport: {
                    '#': '#',
                    'Utterance': 'Utterance',
                },
                perPage: 10,
                fileinput: "",
                sortable: false,
                searchable: true,
                actions: action,
                loadingText: "loading...",
                callbacks: ['delete'],
                editData: {},


            }
        },
        computed: {
            getGroupID() {
                return this.group_id ? this.group_id : null;
            },
            filteredUtterance() {
                return this.utterances.filter(utter => {
                    return utter.text.toLowerCase().includes(this.searchKey.toLowerCase())
                })
            },
            allUtterance() {

                return this.utterances.map((x, index) => {
                    return {
                        "#": index + 1,
                        "Utterance": x.text,
                        "key": x.key
                    }
                });

            },
            paginatedUtterance() {
                const start = this.currentPageIndex * this.perpage,
                    end = start + this.perpage;
                let paged = this.utterances.slice(start, end);
                return paged.filter(utter => {
                    return utter.text.toLowerCase().includes(this.searchKey.toLowerCase())
                })
            },
            pageLength() {
                return (Math.ceil(this.paginatedUtterance.length / this.perpage))
            },
            pages() {
                return (Math.ceil(this.utterances.length / this.perpage))

            },
            utteranceLength() {
                return this.utterances.length;
            },
            getName() {
                return this.intentName;
            },
            getNewName() {
                return this.intentName;
            }


        },
        methods: {
            onFileChange(e) {
                this.uploading = true;
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length)
                    return;
                this.createInput(files[0]);
            },

            createInput(file) {
                let promise = new Promise((resolve, reject) => {
                    var reader = new FileReader();
                    var vm = this;
                    reader.onload = e => {
                        resolve((vm.fileinput = reader.result));
                    };
                    reader.readAsText(file);
                });

                promise.then(
                    result => {

                        let emptyArr = [];
                        /* handle a successful result */

                        let arr = this.fileinput.split("\n").splice(1);
                        arr.forEach((utterance) => {
                            if(utterance.length>1){
                                let newObj = {};
                                newObj["text"] = utterance;
                                this.newUtterances.push(utterance);
                                emptyArr.unshift(newObj);
                                this.newUtterances = [...this.newUtterances];
                                this.utterances = [...emptyArr];
                            }

                        })

                        this.uploading = false;
                        this.$modal.hide('multi-upload');
                    },
                    error => {
                        /* handle an error */
                        this.uploading = false;
                        console.log(error);
                        alert("Error uploading file, please check file and try again")
                    }
                );
            },
            uploadMultiple() {
                this.$modal.show('multi-upload');
            },
            async loadIntent(key) {
                if (!key) return;
                this.loading = true;
                this.focused = "";
                await userService.getIntent(key)
                    .then((res) => {
                        console.log(res);
                        this.loading = false;
                        this.utterances = res.utterances;

                        if (res.json !== null) {
                            res.json.map((res, index) => {
                                return this.responses = res.document;
                            });
                        }
                        console.log(this.responses);

                        //this.doUpdateKey();
                        // this.init();
                        // this.dashboardData = res;


                    }).catch((err) => {
                        this.loading = false;
                        this.$toastr.error(err, "Error fetching intent!", {timeOut: 5000});
                    });
            },
            setPage: function (index) {

                if (index >= 0 && index <= this.pages) {
                    if (index > this.currentPageIndex) this.currentPageIndex++;
                    if (index <= this.currentPageIndex) this.currentPageIndex--;
                    // this.currentPageIndex = index;
                }
            },
            loadTable() {
                this.$nextTick(() => {
                    //  alert('render done')
                    this.table = $('#example').DataTable({
                        dom: 'Bfrtip',
                        buttons: [
                            'copy', 'excel', 'print'

                        ]
                    });
                    // Scroll Down
                })

            },
            editIntentName() {
                let newName = prompt("What will you like to call me?", this.getName);
                if (newName) {
                    this.intentName = newName;
                    // this._intent.name = newName;
                }
            },
            nextPage() {
                this.currentPageIndex++;
            },
            prevPage() {
                this.currentPageIndex--;
            },
            createUtterance() {
                let _self = this;
                let newObj = {};
                let emptyArr = [];
                //let utterance = prompt("Enter new utterance below");


                this.$swal.fire({
                    title: 'New Utterance',
                    input: 'text',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Save',
                    showLoaderOnConfirm: true,
                    preConfirm: async (utterance) => {
                        // alert(login);
                        if (!!utterance) {
                            newObj["text"] = utterance;
                            _self.newUtterances.push(utterance);
                            emptyArr.unshift(newObj);
                            _self.newUtterances = [..._self.newUtterances];
                            _self.utterances = [...emptyArr, ..._self.utterances];

                        }

                    },
                    allowOutsideClick: () => !this.$swal.isLoading()
                }).then((result) => {
                    if (result.dismiss) {
                        return;
                    }
                    // if (result) {
                    //     this.$toastr.success("Saved", "Created Successfully!", {timeOut: 5000});
                    //
                    // }
                })
            },
            async deleteUtterance(index, text) {

                let yesDelete = window.confirm(
                    `Are you sure you want to delete this utterance?`
                );

                if (yesDelete) {
                    this.loading = true;

                    let json = [...this.utterances];

                    await userService.deleteUtterances(this.intent.key, text)
                        .then((res) => {
                            this.loading = false;
                            this.utterances = json.filter(x => x.text !== text);
                            //    json.splice(index, 1);
                            //  this.utterances = json;

                            this.$toastr.success("Saved", ` Successfully Deleted ${text}!`, {timeOut: 5000});
                            // this.loadTable();

                        }).catch((err) => {
                            this.loading = false;
                            this.$toastr.error(err, "Error Deleting intent!", {timeOut: 5000});
                        });
                }

            },


            onDeleteResponse(index) {
                let json = [...this.responses];
                let docObj = {};

                docObj["document"] = json;
                docObj["type"] = "response";
                let arrayIndex = new Array(docObj);
                json.splice(index, 1);
                //arrayIndex.splice(index, 1);
                if (arrayIndex.length === 0) {
                    arrayIndex = null;
                }

                this.responses = json;
                this.newJson = arrayIndex;


            },
            onCreateResponse(type) {
                let newResponse = {};
                newResponse["type"] = type;
                if (type === "quick_replies") {
                    newResponse["quick_replies"] = "default";
                }
                newResponse["text"] = "";
                this.responses.push(newResponse);

            },
            onUpdateResponse(event) {
                let docObj = {};
                let json = [...this.responses];

                docObj["document"] = json;
                docObj["type"] = "response";

                let arrayIndex = new Array(docObj);
                json[event.target.id].text = event.target.value;
                this.focused = event.target.value;
                this.newJson = arrayIndex;

            },
            onFocusResponse(val) {
                this.focused = val;
            },
            doUpdateKey() {
                this.updateKey = Math.ceil((Math.random() + 1) * 10 + (Math.random() + 1));
                this.$emit("onUpdated")
            },
            loadAllScripts() {
                const arr = [
                    'https://cdn.datatables.net/1.10.12/js/jquery.dataTables.min.js', // first script loaded
                    'https://cdn.datatables.net/buttons/1.2.2/js/dataTables.buttons.min.js', // then second script loaded
                    'https://cdn.datatables.net/buttons/1.2.2/js/buttons.flash.min.js', // then second script loaded
                    'https://cdnjs.cloudflare.com/ajax/libs/jszip/2.5.0/jszip.min.js', // then second script loaded
                    'https://cdn.datatables.net/buttons/1.2.2/js/buttons.html5.min.js', // then second script loaded
                    'https://cdn.datatables.net/buttons/1.2.2/js/buttons.print.min.js' // then second script loaded
                ]
                this.$unBlockloadAllScripts(arr)
                    .then(() => {
                        console.log('script loaded')
                        // after all loaded, do your logic
                    })
                    .catch(() => {
                        // after all loaded, do your logic
                    })
            },
            async saveChanges(group_id = null) {
                this.loading = true;

                console.log(this.intent)
                await userService.saveIntents(this.intent.key, this.newUtterances, this.newJson, this.intentName, group_id).then((res) => {
                    console.log(res);
                    this.loading = false;
                    this.doUpdateKey();
                    this.$toastr.success("Great", "Intent saved successfully!", {timeOut: 5000});
                    this.$emit("onUpdated")


                }).catch((err) => {
                    this.loading = false;
                    this.$toastr.error(err, "Error saving intent!", {timeOut: 5000});
                });
            }
        },
        mounted() {
            //this.intent_id=this.keys;
            console.log("mounted");
            this._intent = this.intent;
            this.loadIntent(this.intent.key);
            console.log(this._intent);
            this.intentName = this._intent.name;
            // this.loadAllScripts();


        },
        watch: {
            intent: function (val) {

                //console.log('key chnaged')
                // this._intent = val;
                // this.loadIntent(val.key);
                // console.log(this._intent);
                // this.intentName = this._intent.name;
            },
            utterances: function (val) {

            }

        }
    }
</script>

<style scoped>
    @import url("https://cdn.datatables.net/1.10.12/css/jquery.dataTables.min.css");
    @import url("https://cdn.datatables.net/buttons/1.2.2/css/buttons.dataTables.min.css");

    .list-wrapper ul {
        padding: 0;
        text-align: left;
        list-style: none;
        margin-bottom: 0;
    }

    .pagination {
        padding-top: 20px;
        align-items: center;
        width: 100%;
        text-align: center;
        justify-content: center;
    }

    .pagination span {
        padding: 5px;
    }

    .list-wrapper li {
        font-size: .9375rem;
        padding: .7rem 0;
        line-height: normal;
        border-bottom: 1px solid #ebedf2;
    }

    .align-items-center, .page-header, .loader-demo-box, .list-wrapper ul li, .navbar .navbar-menu-wrapper .navbar-nav .nav-item.dropdown .dropdown-menu.navbar-dropdown .dropdown-item {
        -webkit-box-align: center !important;
        -ms-flex-align: center !important;
        align-items: center !important;
    }

    .justify-content-start, .list-wrapper ul li {
        -webkit-box-pack: start !important;
        -ms-flex-pack: start !important;
        justify-content: flex-start !important;
    }

    .d-flex, .page-header, .loader-demo-box, .list-wrapper ul li, .navbar .navbar-menu-wrapper .navbar-nav .nav-item.dropdown .dropdown-menu.navbar-dropdown .dropdown-item, .navbar .navbar-menu-wrapper .navbar-nav .nav-item.nav-profile .nav-link {
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
    }

    .list-wrapper .remove {
        cursor: pointer;
        font-size: 1.438rem;
        font-weight: 600;
        width: 1.25rem;
        height: 1.25rem;
        line-height: 20px;
        text-align: center;
    }

    .holder {
        box-sizing: border-box;
        padding: 0 20px;
        /*margin-top: 20px;*/
    }

    .list-wrapper .remove:hover {
        color: red !important;
    }

    .text-secondary, .list-wrapper .remove {
        color: #c3bdbd !important;
    }

    .ml-auto, .list-wrapper .remove, .mx-auto {
        margin-left: auto !important;
    }

    .ord {
        margin-right: 10px;
    }

    .pagination .current {
        color: #353cd6;
    }

    .pagination span {
        cursor: grab;
    }

    .create_new {
        position: absolute;
        top: 30px;
        right: 10px;
    }

    fieldset.groupbox-border {
        /*border: 1px groove #ddd !important;*/
        padding: 0 1.4em 1.4em 1.4em !important;
        margin: 1.2em 1.2em 1.2em 1.2em !important;
        -webkit-box-shadow: 0px 0px 0px 0px #000;
        box-shadow: 0px 0px 0px 0px #000;
    }

    legend.groupbox-border {
        font-size: 1em !important;
        font-weight: bold !important;
        text-align: left !important;
        width: auto;
        padding: 0px 10px 0px 10px;
        border-bottom: none;

    }

    .focused_text {
        color: black;
    }

    .save_all {
        position: absolute;
        top: 20px;
        right: 10px;
    }

    .grab {
        cursor: grab;
    }

    .list td {
        padding: 8px 5px;
    }

    .list-wrapper {
        /*overflow-y: scroll;*/
        /*height: 50vh;*/
    }

    table td {
        word-wrap: break-word; /* All browsers since IE 5.5+ */
        overflow-wrap: break-word; /* Renamed property in CSS3 draft spec */
    }

    .dataTables_wrapper .dataTables_filter input {
        border-radius: 5px;
        border: 1px solid black;
    }

    .btn-sm {
        margin-top: 20px;
    }

    [type="file"] {
        height: 0;
        overflow: hidden;
        width: 0;
    }

    [type="file"] + label {
        background: #f15d22;
        border: none;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
        display: inline-block;
        font-family: 'Poppins', sans-serif;
        font-size: inherit;
        font-weight: 600;
        margin-bottom: 1rem;
        outline: none;
        padding: 1rem 50px;
        position: relative;
        -webkit-transition: all 0.3s;
        transition: all 0.3s;
        vertical-align: middle;
    }

    [type="file"] + label:hover {
        background-color: #d3460d;
    }
</style>
